import { jsx as _jsx } from "react/jsx-runtime";
import { FieldType } from '@/catalog/constants/fieldTypes';
import { ALL_CONTEXTS } from '@/common/constants/context';
import { SetupPresetGroupType } from '@/media/entity/SetupPresetGroup';
import MetricScaleContainer from '@/metric/components/MetricScaleContainer/MetricScaleContainer';
import OptMetricBar from '@/metric/components/OptMetricBar/OptMetricBar';
import Diamond from '@/product/entity/Diamond';
export const FIELD_OPTICAL_SYMMETRY = {
    key: 'symmetry.val',
    label: 'O. Symmetry',
    fullLabel: 'Optical Symmetry',
    type: FieldType.Metric,
    spGroupId: SetupPresetGroupType.Aset,
    icon: 'metrics-optical-symmetry',
    getter(p) {
        if (p instanceof Diamond && p.symmetryMetric) {
            return p.symmetryMetric.hr;
        }
        return null;
    },
    getterPlain(p) {
        if (p instanceof Diamond && p.symmetryMetric) {
            return Number(p.symmetryMetric.val);
        }
        return null;
    },
    decorator: (_, p, { ratio, size, label, icon, metricDataDecorator, metricClassName } = {}) => {
        if (p instanceof Diamond) {
            return (_jsx(OptMetricBar, { cutShapeId: p.cutShapeId, metric: p.symmetryMetric, metricDataDecorator: metricDataDecorator, ratio: ratio, type: "symmetry", children: (scale, abs) => (_jsx(MetricScaleContainer, { abs: abs, icon: icon, className: metricClassName, isMetricCalculated: Boolean(p.symmetryMetric), label: label, scale: scale, size: size })) }));
        }
        return null;
    },
    iteratee(p) {
        if (p instanceof Diamond && p.symmetryMetric) {
            return p.symmetryMetric.val;
        }
        return null;
    },
    contexts: ALL_CONTEXTS,
};
